<mat-progress-bar
    class="example-margin"
    [color]="color"
    [mode]="mode">
</mat-progress-bar>